const mockName = [
  "风之旅人",
  "南风知我意",
  "白茶清欢",
  "千夜未央",
  "桜之梦",
  "夜未眠",
  "猫耳娘",
  "千本樱",
  "Zero酱",
  "夜色微光",
  "星空物语",
  "北岛以北",
  "温柔野猫",
  "星河入梦",
  "樱花雨",
  "小熊软糖",
  "初音未来",
  "璃月之风",
  "小宇宙",
  "半夏微凉",
  "小埋",
  "白猫骑士",
  "时光旅人",
  "黑猫侦探",
  "橘子汽水",
  "小甜心",
  "柠檬不酸",
  "落日余晖",
  "柠檬不萌",
  "夏目友人帐",
  "星之彼端",
  "夜空之城",
  "Miku",
  "夜空下的猫",
  "樱落流年",
  "小太阳",
  "南城以南",
  "绯樱",
  "夜色温柔",
  "Sakura梦",
  "白茶清欢",
  "Echo",
  "小宇宙",
  "夜未央",
  "星野遥",
  "初音未来",
  "绯色安然",
  "Zero酱",
  "零崎人识",
  "星河入梦",
  "温柔暴击",
  "小熊软糖",
  "樱花落雨",
  "许瑶",
  "黑羽快斗",
  "小埋",
  "Saber",
  "洛天依",
  "邓晨",
  "小幸运",
  "KuroNeko",
  "夜空下的猫",
  "冯琳",
  "Peachy",
  "萌萌哒",
  "镜音铃",
  "浅笑安然",
  "奶茶不加冰",
  "Chillax",
  "千本樱",
  "Yuki",
  "洛天依",
  "曹宇",
  "绯色安然",
  "星野彼端",
  "镜音双子",
  "温柔以待",
  "Luna",
  "Hoshino",
  "奶盖不加糖",
  "小熊软糖",
  "一只小熊猫",
  "绯色安然",
  "夜未眠",
  "Aqua",
  "黑羽快斗",
  "初音未来",
  "浅夏初雨",
  "夜未央",
  "Saber",
  "清酒暖风",
  "白猫骑士",
  "时雨绮罗",
  "晚风吻我",
  "萌萌哒",
  "Aqua",
  "桜之梦",
  "初音未来",
  "Zero酱",
  "Sakura梦",
  "璃月之风",
];

export const getMockName = (id: number) => {
  return mockName[id % mockName.length];
};
